import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import { HttpModule } from '@angular/http';
import { Market } from '@ionic-native/market';
import { Network } from '@ionic-native/network';
import { FormsModule } from "@angular/forms";
import { HomePage } from '../pages/home/home';
import { TabsPage } from '../pages/tabs/tabs';
import { ProddetailsPage} from '../pages/proddetails/proddetails';
import { MycartPage} from '../pages/mycart/mycart';
import { CheckoutPage } from '../pages/checkout/checkout';
import { LoginPage } from '../pages/login/login';
import { ContactPage } from '../pages/contact/contact';
import { LogoutPage } from '../pages/logout/logout';
import { OrderPage } from '../pages/order/order';
import { ProfilePage } from '../pages/profile/profile';
import { CategoryPage } from '../pages/category/category';
import { MenuPage } from '../pages/menu/menu';
import { RegisterPage } from '../pages/register/register';
import { OrderdetailsPage } from '../pages/orderdetails/orderdetails';
import { OfferPage } from '../pages/offer/offer';
import { AddressPage } from '../pages/address/address';
import { ManageaddressPage } from '../pages/manageaddress/manageaddress';
import { ForgetpasswordPage } from '../pages/forgetpassword/forgetpassword';
import { DeliveryinfoPage } from '../pages/deliveryinfo/deliveryinfo';
import { AboutPage } from '../pages/about/about';
import { WalletPage } from '../pages/wallet/wallet';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { ProductService } from '../pages/service/product_service';
import { UserService } from '../pages/service/user_service';
import { AppSharedService } from '../pages/service/app_shared';
import { NetworkProvider} from '../pages/service/NetworkProvider'

import { ProductfilterPipe } from '../pipes/productfilter/productfilter';
import { IonicStorageModule } from '@ionic/storage';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    TabsPage,
    ProddetailsPage,
    ProductfilterPipe,
    MycartPage,
    CheckoutPage,
    LoginPage,
    ContactPage,
    LogoutPage,
    OrderPage,
    ProfilePage,
    CategoryPage,
    MenuPage,
    RegisterPage,
    OrderdetailsPage,
    OfferPage,
    AddressPage,
    ManageaddressPage,
    DeliveryinfoPage,
    ForgetpasswordPage,
    AboutPage,
    WalletPage
  ],
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    LoginPage,
    TabsPage,
    HomePage,
    ProddetailsPage,
    MycartPage,
    CheckoutPage,
    ContactPage,
    LogoutPage,
    OrderPage,
    ProfilePage,
    CategoryPage,
    MenuPage,
    RegisterPage,
    OrderdetailsPage,
    OfferPage,
    AddressPage,
    ManageaddressPage,
    DeliveryinfoPage,
    ForgetpasswordPage,
    AboutPage,
    WalletPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    ProductService,
    AppSharedService,
    UserService,
    Market,
    Network,
    NetworkProvider,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts